(() => {
  'use strict';
  if (customElements.get('wellhome-hero')) return;

  /*
    El carrusel principal de la home rotaba solo cada 6 segundos y pintaba un boton
    "Pausar" / "Reanudar" para poder detenerlo. Se ha quitado todo: el avance
    automatico, el temporizador, el boton y las paradas por hover, foco, pestana
    oculta y `prefers-reduced-motion`, que existian unicamente para sostenerlo.

    OJO si alguien quiere devolver el avance automatico: el boton NO era decorativo
    ni opcional. El criterio 2.2.2 de las WCAG (Pause, Stop, Hide) exige que todo
    contenido que se mueva solo mas de cinco segundos se pueda pausar. O van los dos
    o no va ninguno; quitar solo el boton cambia una molestia por un incumplimiento.

    El cambio de diapositiva es ahora siempre del usuario, con los puntos. Es lo mismo
    que se hizo en el carrusel de Top ventas y en el de productos relacionados.

    CONSECUENCIA: la segunda diapositiva ya no se muestra sola. Quien no pulse los
    puntos vera solo la primera, asi que lo que vaya en ella tiene que sostenerse por
    si mismo.

    Los atributos `data-autoplay` y `data-autoplay-speed` que sigue emitiendo la
    seccion quedan inertes: ya no los lee nadie.
  */
  class WellHomeHero extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));

      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), { signal }));

      this.show(this.index);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }
  }

  customElements.define('wellhome-hero', WellHomeHero);
})();
